//Function for filter an array with the unique values (to delete the duplicate values)

export default function (arr, predicate) {
    var found = {};
    arr.forEach(d => {
        found[predicate(d)] = d;
    });
    return Object.keys(found).map(key => found[key]);
}